import { commonUtils } from '@/helpers/commonUtils'
import styles from './LayoutHeaderMobile.module.less'
import cls from 'classnames'
import LanguageSwitcher from '@/components/LanguageSwitcher/LanguageSwitcher'
import MenuItemBox from './MenuItemBox/MenuItemBox'
import { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { PAGE_LINKS } from '@/router/pageConst'

interface Props {
  scrollTop: number
}

function LayoutHeaderMobile(props: Props) {
  const [menuVisible, setMenuVisible] = useState(false)
  const headerRef = useRef<HTMLDivElement>(null)
  const active = props.scrollTop !== 0
  const navigate = useNavigate()
  return <div ref={headerRef} className={cls(styles.mobilePageHeader, { [styles.active]: active || menuVisible })} data-testid='layout-header-mobile'>
    <img className={styles.logo} src={commonUtils.getImagePath('homePage/adeff-logo.png')} alt="" data-testid='page-header-mobile-logo-link' onClick={() => {
      navigate(PAGE_LINKS.index)
    }} />
    <div className={styles.menuBox}>
      {!menuVisible && <LanguageSwitcher active={active} />}
      <MenuItemBox active={active} onVisibleChange={(visible) => {
        setMenuVisible(visible)
      }} />
    </div>
  </div>
}



export default LayoutHeaderMobile
